import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { MVTLayer } from "deck.gl";
import type { JunctionFeature } from "@/types/tileFeature";
import { useJunctionTileUrl, JunctionTileSource } from "@/hooks/layers/useJunctionTileUrl";
import { DebounceTimeMilliseconds, MaxConcurrentRequests } from "@/hooks/layers/useTrajectoriesLayer";
import { hexToRgb } from "@/utils/colourUtils";
import { junctionColors } from "@/styles/theme";
export function useJunctionMarkersLayer(visible, onJunctionClick) {
  const $ = _c(6);
  const tileUrl = useJunctionTileUrl(JunctionTileSource.markers);
  const t0 = visible ? tileUrl : null;
  let t1;
  if ($[0] !== onJunctionClick || $[1] !== t0 || $[2] !== visible) {
    let t2;
    if ($[4] !== onJunctionClick) {
      t2 = info => {
        const id = (info.object as JunctionFeature | undefined)?.properties?.id;
        if (id != null) {
          onJunctionClick(id);
        }
      };
      $[4] = onJunctionClick;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = new MVTLayer({
      id: "junction-markers",
      visible,
      data: t0,
      debounceTime: DebounceTimeMilliseconds,
      maxRequests: MaxConcurrentRequests,
      minZoom: 13,
      maxZoom: 16,
      pickable: true,
      autoHighlight: true,
      uniqueIdProperty: "id",
      highlightColor: hexToRgb(junctionColors.markerHighlight),
      pointType: "circle",
      pointRadiusUnits: "pixels",
      pointRadiusMinPixels: 20,
      pointRadiusMaxPixels: 40,
      getFillColor: hexToRgb(junctionColors.marker),
      getLineColor: [0, 0, 0, 0],
      onClick: t2
    });
    $[0] = onJunctionClick;
    $[1] = t0;
    $[2] = visible;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}